import Api from "shared/service/api/api";

// actions
export const LOAD_DISCOUNTS = "loadDiscounts";
export const CREATE_DISCOUNT = "createDiscount";

//mutations
export const SET_DISCOUNTS = "setDiscounts";

const state = {
  discounts: {
    list: [],
    page: 1,
    page_count: 1,
  },
  datasets: {},
};

const actions = {
  [LOAD_DISCOUNTS]({ commit }, { page, name = null, item_id = null }) {
    Api.discount.all(page, name, item_id).then((response) => {
      if (!response.success) {
        throw new Error(response.error);
      }

      commit(SET_DISCOUNTS, response.data);
    });
  },
  [CREATE_DISCOUNT]() {
    return new Promise((resolve) => {
      Api.discount
        .create()
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          resolve(response.data.id);
        })
        .catch(() => {
          resolve(undefined);
        });
    });
  },
};

const mutations = {
  [SET_DISCOUNTS](state, { list, page, page_count }) {
    state.discounts.list = list;
    state.discounts.page = page;
    state.discounts.page_count = page_count;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
